var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    [
      _c("form-document-detail", { attrs: { id: _vm.id } }),
      _c(
        "div",
        { staticClass: "flex flex-row justify-end gap-4" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-secondary" },
              on: { click: _vm.goBack }
            },
            [_vm._v(_vm._s(_vm.$t("action.go_back")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }